import { memo } from 'react';
import type { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';

import resets from '../../../_resets.module.css';
import { ArrowIcon } from './ArrowIcon';
import classes from './Button_circle.module.scss';
  



interface Props {
  className?: string;
  classes?: {
    root?: string;
    text?: string;  // テキストの色を指定するためのクラス
    arrow?: string;  // アイコンの色を指定するためのクラス
  };
  text?:string;
  link?;
}

export const Button_circle: FC<Props> = memo(function Button_circle(props = {}) {
  const location = useLocation(); // 現在のロケーションを取得
  const langCode = location.pathname.split('/')[1] || 'ja'; // URLから言語コードを取得 (デフォルトは 'ja')
  
  return (
    <Link to={`/${langCode}/${props.link}`} className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''} ${classes.Button_circle}`}>
         <div className={`${classes.text} ${props.classes?.text || ''}`}>{props.text || 'LINK'}</div>
         <div className={`arrow1 ${props.classes?.arrow || ''}`} >
          <ArrowIcon className={classes.icon} />
               </div>
    </Link>
  );
});

